export default "__VITE_ASSET__Ddnm1YEC__"